<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import {
		storeUpdateContact,
		storeShowFinishedBlocks,
		storeData,
		storeShowCreateButtons,
		storeUpdateSingle,
	} from '../library/scripts/Store.svelte'
	import { styles } from '../library/scripts/styles'
	import { getCookie } from '../library/scripts/cookie'
	import { update_contact } from '../library/scripts/utils'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../modals/Alert.svelte'

	//get the configFile from storeData
	let configFile
	const stoData = storeData.subscribe((value) => {
		configFile = value
	})
	storeShowCreateButtons.set(false)
	const globals = getContext('globals')
	const colorMain = globals.adminColorMain
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const fsN = globals.fsN
	let backgroundColor = globals.adminInputBgFocus
	let backgroundFocus = globals.adminInputBg
	let buttonBgHover = globals.adminButtonBgHover

	//error handling
	let error = false
	let message = null

	let contactTitle
	let companyName
	let streetName
	let postalCode
	let city
	let country
	let phone
	let email
	let lat
	let lng
	let addMap = false
	let mapLabel

	let ID = getCookie('id')

	configFile.blocks.forEach((block) => {
		if (block.blockName === 'contact') {
			contactTitle = block.titleText
			companyName = block.nameText
			streetName = block.streetText
			postalCode = block.zipText
			city = block.cityText
			country = block.countryText
			phone = block.phoneText
			email = block.emailText
			lat = block.mapLat
			lng = block.mapLng
			mapLabel = block.mapLabel
			addMap = block.map
		}
	})

	const close_contact = () => {
		storeUpdateContact.set(false)
		storeShowFinishedBlocks.set(true)
		storeShowCreateButtons.set(true)
		if ($storeUpdateSingle) {
			const toClose = setTimeout(() => {
				document.location = '#/builder'
				clearTimeout(toClose)
			})
		}
	}

	const upd_contact = async () => {
		if (addMap) {
			//error handling
			if (!mapLabel) {
				error = true
				message = 'Please enter Label'
			}

			if (!lng) {
				error = true
				message = 'Please enter longitude'
			}

			if (!lat) {
				error = true
				message = 'Please enter latitude'
			}

			if (error) return
		}
		const updateContact = await update_contact(
			contactTitle,
			companyName,
			streetName,
			postalCode,
			city,
			country,
			phone,
			email,
			addMap,
			lng,
			lat,
			mapLabel
		)

		if (updateContact) {
			storeData.set(updateContact)
			close_contact()
		}
	}

	const close_alert = () => {
		error = false
	}

	onDestroy(() => {
		stoData
	})
</script>

{#await configFile}
	...file loading
{:then cf}
	{#each cf.blocks as block}
		{#if block.blockName === 'contact'}
			<div transition:slide={{ duration: 1000 }}>
				<div class="contact_title" use:styles={{ colorMain, fsN }}>Contact Block</div>
				<div class="contact_info">
					<div style="display:flex;flex-direction:column;">
						<label for="title" use:styles={{ fsS, colorMain }}>Title</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="title"
							type="text"
							placeholder="title"
							bind:value={contactTitle}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="name" use:styles={{ fsS, colorMain }}>Name / Company </label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="name"
							type="text"
							placeholder="name/company"
							bind:value={companyName}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="street" use:styles={{ fsS, colorMain }}>Street</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="street"
							type="text"
							placeholder="street"
							bind:value={streetName}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="city" use:styles={{ fsS, colorMain }}>City</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="city"
							type="text"
							placeholder="city"
							bind:value={city}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="zip" use:styles={{ fsS, colorMain }}>Postal-Code</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="zip"
							type="text"
							placeholder="postal-code"
							bind:value={postalCode}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="country" use:styles={{ fsS, colorMain }}>Country</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="country"
							type="text"
							placeholder="country"
							bind:value={country}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="phone" use:styles={{ fsS, colorMain }}>Phone</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="phone"
							type="text"
							placeholder="phone"
							bind:value={phone}
						/>
					</div>

					<div style="display:flex;flex-direction:column;">
						<label for="mail" use:styles={{ fsS, colorMain }}>Email Address</label>
						<input
							use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
							id="mail"
							type="text"
							placeholder="email"
							bind:value={email}
						/>
					</div>
				</div>
			</div>

			<div class="contact_map" use:styles={{ colorMain, fsN }}>
				Add Map
				<input id="mpchk" type="checkbox" bind:checked={addMap} />
			</div>
			{#if addMap}
				<div transition:slide={{ duration: 500 }}>
					<div class="contact_info">
						<div style="display:flex;flex-direction:column;">
							<label for="mlabel" use:styles={{ fsS, colorMain }}>Label</label>
							<input
								use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
								id="mlabel"
								type="text"
								placeholder="map label"
								bind:value={mapLabel}
							/>
						</div>

						<div style="display:flex;flex-direction:column;">
							<label for="latitude" use:styles={{ fsS, colorMain }}>Latitude</label>
							<input
								use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
								id="latitude"
								type="text"
								placeholder="latitude"
								bind:value={lat}
							/>
						</div>

						<div style="display:flex;flex-direction:column;">
							<label for="longitude" use:styles={{ fsS, colorMain }}>Longitude</label>
							<input
								use:styles={{ fsS, colorMain, backgroundColor, backgroundFocus }}
								id="longitude"
								type="text"
								placeholder="longitude"
								bind:value={lng}
							/>
						</div>
					</div>
				</div>
			{/if}
		{/if}
	{/each}
{/await}

<div class="button_container">
	<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={close_contact}>close</button>
	<button use:styles={{ colorMain, fsXS, buttonBgHover }} on:click={upd_contact}>update</button>
</div>

{#if addMap && error}
	<Shader>
		<div slot="content"><Alert {message} showOkButton={false} on:alertclose={close_alert} /></div>
	</Shader>
{:else if !addMap && error}
	<Shader>
		<div slot="content"><Alert {message} showOkButton={false} on:alertclose={close_alert} /></div>
	</Shader>
{/if}

<style>
	button {
		background-color: transparent;
		color: var(--colorMain);
		border: 1px solid var(--colorMain);
		font-size: var(--fsXS);
		width: clamp(100px, 13vw, 200px);
		margin-left: 1%;
		padding: 1%;
		border-radius: 5px;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonBgHover);
	}

	label {
		font-size: var(--fsS);
		color: var(--colorMain);
		margin-bottom: 10px;
	}

	input {
		font-size: var(--fsX);
		color: var(--colorMain);
		background: var(--backgroundColor);
		outline: none;
		width: 90%;
		margin-bottom: 10px;
		padding: 10px;
		border: 1px solid green;
	}

	input:focus {
		background-color: var(--backgroundFocus);
	}

	input[type='checkbox'] {
		margin-left: 15px;
		margin-top: 5px;
		padding: 0px;
		outline: none;
	}
	.button_container {
		display: flex;
		width: 100%;
		justify-content: center;
		align-items: center;
		border-top: 1px solid green;
		margin-top: 20px;
		padding-top: 25px;
	}

	.contact_title {
		display: flex;
		justify-content: center;
		padding: 20px;
		font-size: var(--fsN);
		color: var(--colorMain);
	}

	.contact_info {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
		column-gap: 15px;
		row-gap: 15px;
		padding: 2%;
	}

	.contact_map {
		display: inline-grid;
		grid-template-columns: 220px 1fr;
		column-gap: 10px;
		padding: 2%;
		width: 300px;
		justify-items: start;
		align-items: center;
	}
</style>
